// extracted by mini-css-extract-plugin
export default {"products_list":"products-list_products_list__TPcBd","notification_container":"products-list_notification_container__D7zjd","slider":"products-list_slider__pnZId"};